// extracted by mini-css-extract-plugin
export var optionGrid = "_2t-7";
export var optionList = "_2t-6";
export var questionsBlock = "_2t-9";
export var spacer = "_2t-5";
export var stepCenteredContent = "_2t-3";
export var stepInner = "_2t-0";
export var stepInnerFullWidth = "_2t-1";
export var stepInnerLockScroll = "_2t-2";
export var stepTransitionFrame = "_2t-4";
export var welcomeBlock = "_2t-8";